var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_15);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14{stroke-width:0px;}.cls-2{fill:url(#Degradado_sin_nombre_14);}.cls-3{fill:url(#Degradado_sin_nombre_13);}.cls-4{fill:url(#Degradado_sin_nombre_12);}.cls-15{clip-path:url(#clippath);}.cls-5{fill:none;}.cls-16{mask:url(#mask);}.cls-17{clip-path:url(#clippath-1);}.cls-18{clip-path:url(#clippath-4);}.cls-19{clip-path:url(#clippath-3);}.cls-20{clip-path:url(#clippath-2);}.cls-21{clip-path:url(#clippath-7);}.cls-22{clip-path:url(#clippath-6);}.cls-23{clip-path:url(#clippath-5);}.cls-6{fill:url(#Degradado_sin_nombre_15-2);}.cls-7{fill:url(#Degradado_sin_nombre_15-3);}.cls-8{fill:url(#Degradado_sin_nombre_12-2);}.cls-9{fill:url(#Degradado_sin_nombre_13-2);}.cls-10{fill:url(#Degradado_sin_nombre_14-2);}.cls-11{fill:url(#Degradado_sin_nombre_14-3);}.cls-24{mask:url(#mask-3);}.cls-25{mask:url(#mask-2);}.cls-26{mask:url(#mask-4);}.cls-27{mask:url(#mask-1);}.cls-12{fill:#0bd6db;}.cls-13{fill:#03edff;}.cls-14{fill:#00bdd9;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,21c0,11.6-9.4,21-21,21S0,32.6,0,21,9.4,0,21,0s21,9.4,21,21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M.84,26.89c1.3,4.45,4.03,8.29,7.67,10.99,3-1.25,5.59-1.7,5.59-1.7,0,0,2.54-.61,6.46-1.56-2.99-.73-6.78-1.65-10.86-2.66C.25,29.62,1.81,25.07,1.81,25.07c0,0-.46.69-.97,1.82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15",
    x1: 550.15,
    y1: 2665.64,
    x2: 550.27,
    y2: 2665.64,
    gradientTransform: "translate(-92018.45 445887.96) scale(167.26 -167.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0.25,
    y: 25.07,
    width: 20.3,
    height: 12.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.25,
    y: 25.07,
    width: 20.3,
    height: 12.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 550.15,
    y1: 2665.64,
    x2: 550.27,
    y2: 2665.64,
    gradientTransform: "translate(-92018.46 445888) scale(167.26 -167.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04adba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04adba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04adba"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,21c0,11.6-9.4,21-21,21S0,32.6,0,21,9.4,0,21,0s21,9.4,21,21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.45,11.73c3.46.67,6.93,1.48,10.01,2.67.95.37,1.76.75,2.46,1.15,4.45-2.5,4.15-5.46,3.21-7.41-3.93,1.68-9.8,2.45-15.68,3.59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13",
    cx: 537.97,
    cy: 2665.14,
    fx: 537.97,
    fy: 2665.14,
    r: 1,
    gradientTransform: "translate(-3361.77 16842.91) scale(6.32 -6.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 20.45,
    y: 8.14,
    width: 16.92,
    height: 7.41,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.45,
    y: 8.14,
    width: 16.92,
    height: 7.41
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_12",
    cx: 537.97,
    cy: 2665.14,
    fx: 537.97,
    fy: 2665.14,
    r: 1,
    gradientTransform: "translate(-3361.77 16842.91) scale(6.32 -6.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04adba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04adba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04adba"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.07,6.23c3.84-2.11,7.92-2.82,7.92-2.82,0,0,2.54-.61,6.46-1.56-1.43-.35-3.04-.74-4.79-1.17-3.69.97-6.99,2.91-9.59,5.54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15-2",
    x1: 550.15,
    y1: 2664.25,
    x2: 550.28,
    y2: 2664.25,
    gradientTransform: "translate(-92019.28 445628.02) scale(167.26 -167.26)",
    xlinkHref: "#Degradado_sin_nombre_15"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 6.07,
    y: 0.68,
    width: 14.38,
    height: 5.54,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 6.07,
    y: 0.68,
    width: 14.38,
    height: 5.54
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14-2",
    x1: 550.15,
    y1: 2664.25,
    x2: 550.28,
    y2: 2664.25,
    gradientTransform: "translate(-92019.29 445628.06) scale(167.26 -167.26)",
    xlinkHref: "#Degradado_sin_nombre_14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.82,22.93c3.92-1.67,9.76-2.44,15.63-3.58-3.48-.68-6.97-1.48-10.07-2.68-.92-.36-1.72-.73-2.4-1.12-4.39,2.5-4.09,5.44-3.16,7.38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_13-2",
    cx: 541.16,
    fx: 541.16,
    gradientTransform: "translate(-4254.9 20999.3) scale(7.87 -7.87)",
    xlinkHref: "#Degradado_sin_nombre_13"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 3.59,
    y: 15.55,
    width: 16.86,
    height: 7.38,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 3.59,
    y: 15.55,
    width: 16.86,
    height: 7.38
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_12-2",
    cx: 541.16,
    cy: 2665.14,
    fx: 541.16,
    fy: 2665.14,
    r: 1,
    gradientTransform: "translate(-4254.9 20999.3) scale(7.87 -7.87)",
    xlinkHref: "#Degradado_sin_nombre_12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.57,25.06s.04-.04.1-.1c-3.77,2.02-7.71,2.7-7.71,2.7,0,0-2.56.61-6.51,1.57,2.98.72,6.75,1.64,10.81,2.65,2.86.71,4.71,1.62,5.9,2.54,1.63-1.96,2.92-4.23,3.75-6.7-.17-.5-.39-1-.65-1.5-.61-1.14-1.67-2.03-3.07-2.77-.74.57-1.6,1.12-2.61,1.61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_15-3",
    x1: 549.13,
    y1: 2665.58,
    x2: 549.25,
    y2: 2665.58,
    gradientTransform: "translate(-91581.05 444697.71) scale(166.82 -166.82)",
    xlinkHref: "#Degradado_sin_nombre_15"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 20.45,
    y: 23.45,
    width: 20.45,
    height: 10.97,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 20.45,
    y: 23.45,
    width: 20.45,
    height: 10.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14-3",
    x1: 549.13,
    y1: 2665.58,
    x2: 549.25,
    y2: 2665.58,
    gradientTransform: "translate(-91581.05 444697.71) scale(166.82 -166.82)",
    xlinkHref: "#Degradado_sin_nombre_14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42,21c0,11.6-9.4,21-21,21S0,32.6,0,21,9.4,0,21,0s21,9.4,21,21"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M9.69,31.96C.25,29.62,1.81,25.07,1.81,25.07c0,0-4.35,6.51-1.11,12.55.61,1.14,1.67,2.03,3.07,2.77.05.02.09.05.14.07.72-.55,1.48-1.03,2.26-1.45,3.84-2.12,7.93-2.83,7.93-2.83,0,0,2.54-.61,6.46-1.56-2.99-.73-6.78-1.65-10.86-2.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.25,
    y: 25.07,
    width: 20.3,
    height: 12.81
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M32.92,15.55c4.45-2.5,4.15-5.46,3.21-7.41-3.93,1.68-9.8,2.45-15.68,3.59,3.46.67,6.93,1.48,10.01,2.67.95.37,1.76.75,2.46,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.98,15.55c-4.39,2.5-4.09,5.44-3.16,7.38,3.92-1.67,9.76-2.44,15.63-3.58-3.48-.68-6.97-1.48-10.07-2.68-.92-.36-1.72-.73-2.4-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M34.67,24.96c-3.77,2.02-7.71,2.7-7.71,2.7,0,0-2.56.61-6.51,1.57,2.98.72,6.75,1.64,10.81,2.65,9.44,2.33,7.88,6.88,7.88,6.88,0,0,4.35-6.51,1.11-12.55-.61-1.14-1.67-2.03-3.07-2.77-.74.57-1.6,1.12-2.61,1.61,0,0,.04-.04.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M9.59-.81C.15-3.14,1.7-7.69,1.7-7.69,1.7-7.69-2.65-1.19.59,4.85c.61,1.14,1.67,2.03,3.07,2.77.05.02.09.05.14.07.72-.55,1.48-1.03,2.26-1.45,3.84-2.12,7.93-2.83,7.93-2.83,0,0,2.54-.61,6.46-1.56-2.99-.73-6.78-1.65-10.86-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M34.67,24.96c-.06.07-.1.1-.1.1,1.01-.49,1.87-1.05,2.61-1.61-.02-.01-.05-.02-.07-.04-.78.59-1.6,1.1-2.44,1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.19-7.69s1.55,4.55-7.88,6.88c-4.08,1.01-7.87,1.93-10.86,2.66-3.92.95-6.46,1.56-6.46,1.56,0,0-4.09.71-7.93,2.83-.77.43-1.54.91-2.26,1.45C.99,9.83-1.12,12.92-.41,17.31c.55,2.6,2.2,4.59,4.2,6.1.33-.17.67-.33,1.03-.48-.93-1.94-1.23-4.88,3.16-7.38.7-.4,1.51-.78,2.46-1.15,3.08-1.19,6.55-2,10.01-2.67,5.88-1.14,11.75-1.92,15.68-3.59.34-.14.66-.29.96-.45.05-.02.09-.05.14-.07,1.39-.74,2.46-1.63,3.07-2.77,3.24-6.04-1.11-12.55-1.11-12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.09,7.69c-.31.16-.63.31-.96.45.94,1.95,1.24,4.91-3.21,7.41-.68.39-1.48.76-2.4,1.12-3.09,1.2-6.58,2-10.07,2.68-5.87,1.14-11.71,1.91-15.63,3.58-.36.15-.71.31-1.03.48-.02.01-.05.02-.07.04-1.39.74-2.46,1.63-3.07,2.77-3.24,6.04,1.11,12.55,1.11,12.55,0,0-1.55-4.55,7.88-6.88,4.06-1,7.83-1.92,10.81-2.65,3.95-.96,6.51-1.57,6.51-1.57,0,0,3.93-.68,7.71-2.7.84-.45,1.66-.96,2.44-1.55,2-1.51,3.66-3.5,4.2-6.1.71-4.39-1.41-7.48-4.22-9.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.92,15.55c4.45-2.5,4.15-5.46,3.21-7.41-3.93,1.68-9.8,2.45-15.68,3.59,3.46.67,6.93,1.48,10.01,2.67.95.37,1.76.75,2.46,1.15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.45,
    y: 8.14,
    width: 16.92,
    height: 7.41
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 6.07,
    y: 0.68,
    width: 14.38,
    height: 5.54
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3.59,
    y: 15.55,
    width: 16.86,
    height: 7.38
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 20.45,
    y: 23.45,
    width: 20.45,
    height: 10.97
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.65,22.85c-.31.16-.63.31-.96.45.94,1.95,1.24,4.91-3.21,7.41-.68.39-1.48.76-2.4,1.12-3.09,1.2-6.58,2-10.07,2.68-5.87,1.14-11.71,1.91-15.63,3.58-.36.15-.71.31-1.03.48-.02.01-.05.02-.07.04-1.39.74-2.46,1.63-3.07,2.77-3.24,6.04,1.11,12.55,1.11,12.55,0,0-1.55-4.55,7.88-6.88,4.06-1,7.83-1.92,10.81-2.65,3.95-.96,6.51-1.57,6.51-1.57,0,0,3.93-.68,7.71-2.7.84-.45,1.66-.96,2.44-1.55,2-1.51,3.66-3.5,4.2-6.1.71-4.39-1.41-7.48-4.22-9.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.62fe483bc4518b3001c3b34a6d9a8671.svg";
export { ForwardRef as ReactComponent };